// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorComponent_container__gwUII"};